import { render, staticRenderFns } from "./ButtonsWithTextBoxDialog.vue?vue&type=template&id=42874fc2&scoped=true&"
import script from "./ButtonsWithTextBoxDialog.vue?vue&type=script&lang=js&"
export * from "./ButtonsWithTextBoxDialog.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsWithTextBoxDialog.vue?vue&type=style&index=0&id=42874fc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42874fc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VSelect,VTextField})
